// replaces underscores and hyphens with spaces,
// Words shorter than 4 letters → all uppercase
// Words 4 letters or longer → first letter capitalized
export const formatLabel = (key: string) => {
  return key
    .replace(/_/g, " ")
    .replace(/-/g, " ")
    .split(" ")
    .map((word) =>
      word.length < 4
        ? word.toUpperCase()
        : word[0].toUpperCase() + word.slice(1)
    )
    .join(" ");
};


// replaces underscores and hyphens with spaces,
// first letter capitalized
export const formatLabel2 = (key: string) => {
  return key
    .replace(/_/g, " ")
    .replace(/-/g, " ")
    .split(" ")
    .join(" ");
};



// formatLabel3 combines formatLabel2 + conditional formatLabel logic
export const formatLabel3 = (key: string) => {
  const specialKeys = ["build_your_pc", "template", "standalone"];

  // If key is one of the special ones, use formatLabel logic
  if (specialKeys.includes(key)) {
    return key
      .replace(/_/g, " ")
      // .replace(/-/g, " ")
      .split(" ")
      .map((word) =>
        word.length < 4
          ? word.toUpperCase()
          : word[0].toUpperCase() + word.slice(1)
      )
      .join(" ");
  }

  // Otherwise, use formatLabel2 logic
  // return key.replace(/_/g, " ").replace(/-/g, " ").split(" ").join(" ");
  return key.replace(/_/g, " ").split(" ").join(" ");
};




